import styled from '@emotion/styled';

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`;

export const StyledTh = styled.th`
  padding: ${props => props.theme.spacing[2]}px ${props => props.theme.spacing[2]}px;
  font-size: ${props => props.theme.fontSize.md}px;
  font-weight: ${props => props.theme.fontWeight.semibold};
  color: ${props => props.theme.colors.text.primary};
  text-align: center;
  background: ${props => props.theme.colors.surface.group.default};
  border-bottom: 1px solid ${props => props.theme.colors.border.divider};
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const StyledTr = styled.tr<{ isExpanded: boolean; isConnected?: boolean }>`
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${props =>
    props.isConnected ? props.theme.colors.surface.interactive.selectedContent : 'transparent'};
  border-bottom: ${props =>
    props.isExpanded ? 'none' : `1px solid ${props.theme.colors.border.divider}`};

  &:hover {
    background-color: ${props => props.theme.colors.surface.interactive.hover};
  }
`;

export const StyledTd = styled.td`
  padding: ${props => props.theme.spacing[2]}px ${props => props.theme.spacing[2]}px;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;

  /* Text 컴포넌트(<p>)의 기본 text-align: left 를 중앙정렬로 덮어씀 */
  p {
    text-align: center;
  }

  /* img는 inline 요소라 text-align 만으로 중앙정렬 안됨 */
  > img {
    display: block;
    margin: 0 auto;
  }
`;

export const ExpandedContent = styled.div`
  padding: ${props => props.theme.spacing[3]}px;
  padding-left: ${props => props.theme.spacing[10]}px;
  background-color: ${props => props.theme.colors.surface.layout.container};
  border-top: 1px solid ${props => props.theme.colors.border.divider};
  border-bottom: 1px solid ${props => props.theme.colors.border.divider};
`;

export const SensorDataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border-bottom: 1px solid ${props => props.theme.colors.border.divider};
    padding: 8px;
    text-align: left;
    word-wrap: break-word;
  }

  th {
    background-color: ${props => props.theme.colors.surface.group.default};
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  td {
    background-color: ${props => props.theme.colors.surface.layout.container};
  }

  th:first-of-type,
  td:first-of-type {
    width: 200px;
    min-width: 200px;
  }

  tbody tr:hover {
    background-color: ${props => props.theme.colors.surface.interactive.hover};
  }
`;

export const DataBox = styled.div<{ deviceType: 'belllite' | 'bellmini' }>`
  width: 280px;
  min-width: 280px;
  height: auto;
  border: 1px solid ${props => props.theme.colors.border.divider};
  border-right: ${props =>
    props.deviceType === 'bellmini'
      ? `1px solid ${props.theme.colors.border.divider}`
      : `2px solid ${props.theme.colors.border.divider}`};
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.surface.layout.container};
`;

export const DataBoxHeader = styled.div`
  background: ${props => props.theme.colors.surface.group.default};
  padding: ${props => props.theme.spacing[3]}px 8px;
  font-size: ${props => props.theme.fontSize.md}px;
  font-weight: ${props => props.theme.fontWeight.semibold};
  color: ${props => props.theme.colors.text.primary};
  border-bottom: 1px solid ${props => props.theme.colors.border.divider};
`;

export const TableHead = styled.thead`
  background: ${props => props.theme.colors.surface.header.nested};
  border-bottom: 1px solid ${props => props.theme.colors.border.divider};
`;

export const TableHeaderCell = styled.th`
  padding: ${props => props.theme.spacing[3]}px 8px;
  font-size: ${props => props.theme.fontSize.md}px;
  font-weight: ${props => props.theme.fontWeight.semibold};
  color: ${props => props.theme.colors.text.primary};
  text-align: center;
`;

export const DataBoxRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${props => props.theme.colors.surface.interactive.hover};
  }
`;

export const DataBoxLabel = styled.span`
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeight.medium};
  color: ${props => props.theme.colors.text.secondary};
`;

export const DataBoxValue = styled.span`
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeight.regular};
  color: ${props => props.theme.colors.text.primary};
`;
